import moment from 'moment'
import React, { useState } from 'react'
import ReactModal from 'react-modal'
import { BoxModal } from '../../boxModal';
import { useAuth } from '../../../hooks/useAuth';
import { FaCreditCard, FaPix } from "react-icons/fa6";
import { toast } from 'react-toastify';
import { useCards } from '../../../hooks/useCards';

const InvoicePaymentSection = ({ invoice }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('balance');

  const { account } = useAuth();
  const { payInvoice } = useCards();

  const hasSufficientBalance = () => account.balance.avaliableBalance > invoice.totalAmount;
  const displayAccountBalance = () => Number(account.balance.avaliableBalance).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const displayInvoiceAmount = () => Number(invoice.totalAmount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const displayInvoiceDueDate = () => moment(invoice.dueDate).format('DD/MM/YYYY');
  const handlePaymentMethodChange = (event) => {
    setSelectedPaymentMethod(event.target.id);
  };

  const handlePayment = async () => {
    if (selectedPaymentMethod === 'balance' && !hasSufficientBalance()) {
      toast.error('Saldo insuficiente');
      return;
    }

    try {
      setIsLoading(true);
      const result = await payInvoice({
        invoiceId: invoice.id,
        paymentMethod: selectedPaymentMethod,
        amount: invoice.totalAmount,
      });
      if (result) {
        toast.success('Pagamento realizado com sucesso!');
        setIsOpenModal(false);
      }
    } catch (err) {
      toast.error('Erro ao processar pagamento');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="payment-section">
        <div className="payment-summary">
          <div className="payment-info">
            <div className="payment-title">Valor total da fatura</div>
            <div className="payment-value danger">{displayInvoiceAmount()}</div>
            <div className="payment-detail">Vencimento em {displayInvoiceDueDate()}</div>
          </div>
          <div className="payment-action">
            <button className="button" onClick={() => setIsOpenModal(true)}>Pagar Fatura</button>
          </div>
        </div>
        <div className="payment-note">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          <span>O pagamento será realizado pelo valor total da fatura. Após confirmar, você será redirecionado para escolher a forma de pagamento.</span>
        </div>
      </div>
      <ReactModal
        isOpen={isOpenModal}
        className="invoice-payment-modal"
        overlayClassName="overlay-invoice-payment-modal"
      >
        <BoxModal
          maxWidth={600}
          close={() => setIsOpenModal(false)}
          title="Confirmar de pagamento"
        >
          <div className="modal-body">
            <p>Você está prestes a pagar o valor total da fatura.</p>
            <div className="confirmation-details">
              <div className="detail-row">
                <span>Valor:</span>
                <span className="value">{Number(invoice.totalAmount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
              </div>
              <div className="detail-row">
                <span>Data:</span>
                <span>{moment(invoice.dueDate).format('DD/MM/YYYY')}</span>
              </div>
            </div>
            <p className="payment-question">Como você deseja pagar?</p>
            <div className="payment-methods">
              <div className="payment-method">
                <input type="radio" name="paymentMethod" id="balance" onChange={handlePaymentMethodChange} />
                <label
                  className={hasSufficientBalance() ? '' : 'payment-method-disabled'}
                  for="balance"
                  title={hasSufficientBalance() ? '' : 'Saldo insuficiente para pagamento'}
                >
                  <div className="method-icon">
                    <FaCreditCard />
                  </div>
                  <div className="method-info">
                    <div className="method-name">Saldo em Conta</div>
                    <div className="method-detail">Conta {account.bankAccount}-{account.bankAccountDigit} | Saldo: {displayAccountBalance()}</div>
                  </div>
                </label>
              </div>
              {/* <div className="payment-method">
                <input type="radio" name="paymentMethod" id="pix" onChange={handlePaymentMethodChange}/>
                <label
                  className='payment-method-disabled'
                  for="pix"
                  title='Em breve'
                >
                  <div className="method-icon">
                    <FaPix />
                  </div>
                  <div className="method-info">
                    <div className="method-name">Pagar com PIX</div>
                    <div className="method-detail">Pagamento instantâneo</div>
                  </div>
                </label>
              </div> */}
            </div>
          </div>
          <div className="payment-modal-footer">
            <button className="modal-button cancel" onClick={() => setIsOpenModal(false)}>Cancelar</button>
            <button className="modal-button confirm" onClick={isLoading ? null : handlePayment}>
              {isLoading ? "Processando..." : "Confirmar Pagamento"}
            </button>
          </div>
        </BoxModal>
      </ReactModal>
    </>
  )
}

export default InvoicePaymentSection
